import { istek } from './istemci';
import type { Semalar } from './sema';
import type { Kimlik } from './tipler';

/**
 * VARDİYA UÇLARI.
 *
 * Tipler `schema.d.ts`ten TÜRETİLİR; elle yazılmaz.
 *
 * SAATLER `"07:00"` BİÇİMİNDE METİN — `Date` değil. Sunucu `to_char` ile
 * çeviriyor; ayrıştırmaya kalkışılmamalı.
 */

export type PlanGunTipi = Semalar['PlanIzgaraSatiriDto']['gunTipi'];
export type PlanDurum = Semalar['PlanUretimOzetiDto']['durum'];
export type IhlalSeviyesi = Semalar['PlanIhlaliDto']['seviye'];

export type PlanIzgaraSatiri = Semalar['PlanIzgaraSatiriDto'];
export type PlanKotaSatiri = Semalar['PlanKotaSatiriDto'];
export type PlanUretimOzeti = Semalar['PlanUretimOzetiDto'];
export type PlanIhlali = Semalar['PlanIhlaliDto'];
export type PlanUretimRaporu = Semalar['PlanUretimRaporuDto'];

/** İstemci tarafı sorgu şekli — hiçbir DTO'nun karşılığı değildir. */
export interface PlanSorgusu {
  birimId: Kimlik;
  /** ISO tarih (`2026-09-01`). */
  baslangic: string;
  bitis: string;
}

/* ------------------------------------------------------------------ */

export function planIzgarasi(sorgu: PlanSorgusu): Promise<PlanIzgaraSatiri[]> {
  return istek<PlanIzgaraSatiri[]>('/v1/vardiya/plan', { sorgu: { ...sorgu } });
}

export function planUretimleri(sorgu: PlanSorgusu): Promise<PlanUretimOzeti[]> {
  return istek<PlanUretimOzeti[]>('/v1/vardiya/plan/uretim', { sorgu: { ...sorgu } });
}

export function planDogrula(sorgu: PlanSorgusu): Promise<PlanIhlali[]> {
  return istek<PlanIhlali[]>('/v1/vardiya/plan/dogrula', { sorgu: { ...sorgu } });
}

export function kotaRaporu(planUretimiId: Kimlik): Promise<PlanKotaSatiri[]> {
  return istek<PlanKotaSatiri[]>(`/v1/vardiya/plan/${planUretimiId}/kota`);
}

/**
 * Plan üretir. TASLAK bırakır — onaylanmadan personele gitmez.
 *
 * `rotasyonDeseniId` boş bırakılırsa sunucu birime özel deseni, yoksa kurum
 * genelini seçer.
 */
export function planUret(girdi: {
  birimId: Kimlik;
  donemBaslangic: string;
  rotasyonDeseniId?: number;
}): Promise<PlanUretimRaporu> {
  return istek<PlanUretimRaporu>('/v1/vardiya/plan/uret', {
    yontem: 'POST',
    govde: girdi,
  });
}

/**
 * Planı onaylar. 204 döner.
 *
 * `uyariGerekcesi` UYARI VARSA ZORUNLU; sunucu eksikse 400 verir. Engel
 * varsa gerekçeyle de geçilemez.
 */
export function planOnayla(planUretimiId: Kimlik, uyariGerekcesi?: string): Promise<void> {
  return istek<void>(`/v1/vardiya/plan/${planUretimiId}/onayla`, {
    yontem: 'PATCH',
    govde: uyariGerekcesi === undefined ? {} : { uyariGerekcesi },
  });
}
